import { SnackbarProvider } from "notistack";
import { ReactElement, useContext } from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "./layout/layout";
import UnauthLayout from "./layout/unauth-layout";
import { DetailPage, Files, NotFound, Settings } from "./pages";
import Collection from "./pages/collection/collection";
import Collections from "./pages/collections/collections";
import Share from "./pages/share/Share";
import AssetProvider from "./providers/asset-provider";
import BrandProvider from "./providers/brand-provider";
import CategoryProvider from "./providers/category-provider";
import { UserInfoContext } from "./providers/graphql-provider";
import UserProvider from "./providers/user-provider";

function App(): ReactElement {
  const { isPublicUser } = useContext(UserInfoContext);

  if (isPublicUser) {
    return (
      <Routes>
        <Route path="/" element={<UnauthLayout />}>
          <Route path="share/:id" element={<Share />} />
        </Route>
      </Routes>
    );
  }

  return (
    <UserProvider>
      <CategoryProvider>
        <BrandProvider>
          <AssetProvider>
            <SnackbarProvider>
              <Routes>
                <Route path="/" element={<Layout />}>
                  {/* <Route index element={<Home />} /> */}
                  <Route index element={<Files />} />
                  <Route path="file/:id/:offset" element={<DetailPage />} />
                  <Route path="collections" element={<Collections />} />
                  <Route path="collection/:id" element={<Collection />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="*" element={<NotFound />} />
                  <Route path="not-found" element={<NotFound />} />
                  <Route path="share/:id" element={<Share />} />
                </Route>
              </Routes>
            </SnackbarProvider>
          </AssetProvider>
        </BrandProvider>
      </CategoryProvider>
    </UserProvider>
  );
}

export default App;
